export const URL_PROD = process.env.REACT_APP_URL_PROD;
export const URL_DEV = process.env.NODE_ENV;